import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import { downloadSqlReportQuery, exportSqlReportQuery } from 'api';
import { handleSqlReportError } from 'helpers/errors';
import Spinner from 'components/Spinner';

class ReportQueriesTable extends Component {
  state = {
    loading: false,
  };

  handleDownload = async (id) => {
    try {
      this.setState({ loading: true });
      const response = await downloadSqlReportQuery(id);
      const href = URL.createObjectURL(response.data);
      // create "a" HTML element with href to file & click
      const link = document.createElement('a');
      link.href = href;
      document.body.appendChild(link);
      link.click();
      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
      toast.success('Report query downloaded');
    } catch (e) {
      toast.error(handleSqlReportError(e));
    } finally {
      this.setState({ loading: false });
    }
  };

  handleGSheet = async (id) => {
    try {
      this.setState({ loading: true });
      const response = await exportSqlReportQuery(id);
      toast.success(
        () => (
          <div>
            <a
              href={response.data.report_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              View Google Sheet
            </a>
          </div>
        ),
        { autoClose: false },
      );
    } catch (e) {
      toast.error(handleSqlReportError(e));
    } finally {
      this.setState({ loading: false });
    }
  };

  renderTableRow = ({ id, name }) => {
    const { sqlReport } = this.props;
    return (
      <tr key={id}>
        <td>{id}</td>
        <td>{name}</td>
        <td style={{ minWidth: '77px', width: '77px' }}>
          <Link
            to={`/reporting/automated-reports/${sqlReport.id}/report-queries/${id}/view`}
          >
            <button className="btn btn-default">View</button>
          </Link>
        </td>
        <td style={{ minWidth: '275px', width: '275px' }}>
          <button
            onClick={() => this.handleDownload(id)}
            className="btn btn-default mar-r"
          >
            Download
          </button>
          <button
            onClick={() => this.handleGSheet(id)}
            className="btn btn-default"
          >
            Export to GSheets
          </button>
        </td>
      </tr>
    );
  };

  render() {
    const { sqlReport } = this.props;
    const { loading } = this.state;
    const report_queries = (sqlReport && sqlReport.report_queries) || [];
    return (
      <div className="relative">
        <h3>Report Queries</h3>
        <table className="table">
          <thead>
            <tr>
              <th>Id</th>
              <th>Name</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>{report_queries.map(this.renderTableRow)}</tbody>
        </table>
        <Spinner showLoader={loading} />
      </div>
    );
  }
}

export default ReportQueriesTable;
